export const videoPageBar = {
  background: "transparent",
  padding: " 1em",
  display: "flex",
  justifyContent: "space-between",
};

export const videPageContainer = {
  display: "flex",
  flexDirection: "column",
};

export const videoFrame = {
  display: "flex",
  justifyContent: "center",
  alignItem: "center",
  // flexDirection:"column"
};

export const videoPlayer = {
  // minWidth: "10vw",
  // minHeight:"10vh",
  width: "87vw",
  height: "70vh",
  borderRadius: "10px",
};

export const videoCards = {
  marginTop: "10px",
  marginBottom: "3em",
};

export const videoContentArea = {
  display: "flex",
  flexDirection: "row",
  alignContent: "center",
  justifyContent: "space-between",
  flexWrap:"wrap"
};

export const videoDescription = {
  marginLeft: "10em",
  marginTop:"2em"
};

export const videoButton = {
   marginTop:"2em",
  marginRight:"10em"
}

export const dividerStyle = {
  // BackgroundColor: "black",
  margin: "50px 7rem",
  display: "flex",
  justifyContent: "center",
  alignItem: "center",
  // border:"none"
};
